import { render, staticRenderFns } from "./TabsDetailsFicheReclamation.vue?vue&type=template&id=5e9d4361&"
import script from "./TabsDetailsFicheReclamation.vue?vue&type=script&lang=js&"
export * from "./TabsDetailsFicheReclamation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports